import { atom } from "jotai";

import { dictReadyAtom } from "@/atoms/dict";
import type { UserInfo } from "@/types/auth";

/** 当前登录用户 */
export const currentUserAtom = atom<UserInfo | null>(null);

/** 当前用户权限码列表 */
export const permissionsAtom = atom<string[]>([]);

/** 是否已完成鉴权初始化（避免闪烁） */
export const authReadyAtom = atom(false);

/** 登录 / 登出会话版本，递增后触发鉴权与字典重新初始化 */
export const authSessionAtom = atom(0);

/**
 * 通知会话变更（登录成功、退出登录后调用）
 * 同步置为未就绪，避免 navigate 后业务页在 bootstrap 完成前发请求
 */
export const bumpAuthSessionAtom = atom(null, (get, set) => {
  set(authReadyAtom, false);
  set(dictReadyAtom, false);
  set(authSessionAtom, get(authSessionAtom) + 1);
});
